import { L as i } from "../chunks/Linkify-V7PfCeZ8.mjs";
const r = function(t, e) {
  e.value?.linkify === !0 && (t.innerHTML = i(e.value.text));
};
export {
  r as default,
  r as directive
};
